module.exports = __webpack_public_path__ + "static/media/template_articles.6e12fba2.csv";